import { Routes, Route, Navigate } from "react-router-dom"
import { useUser } from "reactfire"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Dashboard from "./pages/Dashboard"
import PrivateRoute from "./components/PrivateRoute"

// Ruta pública: si ya hay sesión activa, redirige al dashboard
function PublicRoute({ children }) {
  const { data: user, status } = useUser()

  if (status === "loading") return null // esperar sin redirigir

  return user ? <Navigate to="/dashboard" replace /> : children
}

function App() {
  return (
    <Routes>
      {/* / → dashboard si hay sesión, login si no */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route path="/login"    element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
    </Routes>
  )
}

export default App